import { render, staticRenderFns } from "./RegisterAffiliate.vue?vue&type=template&id=321b4a8e&scoped=true&"
import script from "./RegisterAffiliate.vue?vue&type=script&lang=js&"
export * from "./RegisterAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAffiliate.vue?vue&type=style&index=0&id=321b4a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b4a8e",
  null
  
)

export default component.exports